export const styles = {
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  box: {
    padding: '8px 24px 24px 24px',
    //width: '362px',
    // minWidth: '362px',
  },
  isBottom: {
    padding: '8px 24px 12px 24px',
  },
}
